import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonRecipeModel } from 'src/app/model/common/recipe';
import { RECIPE_CONSTANTS } from './general-recipe.constants';

@Component({
  selector: 'ms-consult-recipe-item',
  templateUrl: './general-recipe-item.component.html',
})
export class GeneralRecipeItemComponent {
  readonly screen = RECIPE_CONSTANTS;
  @Input() turn = -1;
  @Input() idx = -1;
  @Input() recipe: CommonRecipeModel = {};
  @Output() recipeChange: EventEmitter<CommonRecipeModel> = new EventEmitter();
  @Output() remove: EventEmitter<void> = new EventEmitter();
  @Input() readonly = false;

  handleAutocompleteChange = () => {
    if (this.recipe.medicineHelp) {
      this.recipe.medicineHelp.id = undefined;
    }
    this.recipeChange.emit(this.recipe);
  };
}
